import { render, staticRenderFns } from "./group_summary_panel.vue?vue&type=template&id=655c7d20&scoped=true&"
import script from "./group_summary_panel.vue?vue&type=script&lang=ts&"
export * from "./group_summary_panel.vue?vue&type=script&lang=ts&"
import style0 from "./group_summary_panel.vue?vue&type=style&index=0&id=655c7d20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c7d20",
  null
  
)

export default component.exports